'use client';

import { Locale } from '@eos/shared-locale-utility/locale';
import { AdapterDateFns, LocalizationProvider } from '@zeus/core';
import type { Locale as DateFnsLocale } from 'date-fns';
import { de, enGB, enUS, es, fr, it, nl, pl, pt } from 'date-fns/locale';
import { PropsWithChildren, useMemo } from 'react';

const localeMap: Partial<Record<Locale, DateFnsLocale>> = {
  'en-GB': enGB,
  'en-US': enUS,
  'pt-PT': pt,
  de,
  fr,
  es,
  it,
  nl,
  pl,
};

type DateLocalizationProviderProps = PropsWithChildren<{ locale: Locale }>;

export const DateLocalizationProvider = ({
  locale,
  children,
}: DateLocalizationProviderProps) => {
  const adapterLocale = useMemo(() => localeMap[locale] ?? enGB, [locale]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={adapterLocale}
    >
      {children}
    </LocalizationProvider>
  );
};
